'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Image;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Image(props) {
  var imageSrc = props.imageSrc,
      width = props.width,
      height = props.height,
      alt = props.alt,
      title = props.title;
  var styles = {
    padding: '.5em'
  };
  return _react2.default.createElement('img', {
    width: width,
    height: height,
    style: styles,
    alt: alt,
    title: title,
    src: imageSrc
  });
}

Image.propTypes = {
  imageSrc: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  alt: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired
};
Image.defaultProps = {
  width: '',
  height: ''
};